import { parseStringDate } from '@/util/date'
import { setProps } from '@/util/object.ts'
import { InitialData } from '~common/serverToClientParser'

import { AppState, Conversation, InternalConversation } from '../stateType'

type WireConversation = InitialData['conversations'][number]
type WireTriage = WireConversation['triage']

// Wire triage may omit answers; the store's Triage requires them.
export const normalizeTriage = (triage: WireTriage) =>
  triage ? { ...triage, answers: triage.answers ?? {} } : undefined

// The wire contract uses nullish fields; the store uses undefined and Dates.
// Normalize once here so the rest of the app works with the strict types.
const toInternalConversation = (
  ic: WireConversation['internalConversation'],
): InternalConversation | undefined =>
  ic
    ? {
        assignedToId: ic.assignedToId,
        assignedToName: ic.assignedToName ?? undefined,
        closedAt: parseStringDate(ic.closedAt),
        conversationId: ic.conversationId,
        createdById: ic.createdById,
        createdByName: ic.createdByName ?? undefined,
        events: ic.events,
        id: ic.id,
      }
    : undefined

export const toConversation = (c: WireConversation): Conversation => ({
  assignedToId: c.assignedToId ?? undefined,
  assignedToName: c.assignedToName ?? undefined,
  closedAt: parseStringDate(c.closedAt),
  events: c.events,
  id: c.id,
  internalConversation: toInternalConversation(c.internalConversation),
  lastMessageTime: parseStringDate(c.lastMessageTime),
  patient: c.patient,
  priority: c.priority,
  queueId: c.queueId,
  reasonForEntryId: c.reasonForEntryId ?? undefined,
  reasonForEntryTitle: c.reasonForEntryTitle ?? undefined,
  triage: normalizeTriage(c.triage),
})

export default function handleInitialData(
  state: AppState,
  ev: InitialData,
): AppState {
  return setProps(state, {
    clinicians: ev.clinicians,
    conversations: ev.conversations.map(toConversation),
    isInitialized: true,
    queues: ev.queues,
    reasonsForEntry: ev.reasonsForEntry,
    user: {
      ...ev.user,
      email: ev.user.email ?? '',
      permissions: ev.user.permissions ?? [],
    },
  })
}
